import { connect } from 'react-redux';

import { IState } from '../../../store';
import { CommercialAboutOther, ICommercialAboutOtherProps } from './index';

function mapStateToProps(state: IState): ICommercialAboutOtherProps {
  return {
    building: state.offerData.offer.building,
    businessShoppingCenter: state.offerData.businessShoppingCenter,
    offer: state.offerData.offer,
  };
}

export const CommercialAboutOtherContainer = connect<ICommercialAboutOtherProps, {}, {}>(mapStateToProps)(
  CommercialAboutOther,
);
